/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  TopCustomersByEarliestContactDto,
  TopCustomersByEarliestContactValue,
} from '@gh/builder-shared-data';

export type TopCustomersByEarliestContact = TopCustomersByEarliestContactDto;

export const topCustomersByEarliestContactFromDto = (dto: TopCustomersByEarliestContact[]):
  TopCustomersByEarliestContact[] => dto.map((item: TopCustomersByEarliestContact) => {
  const label = 1 === item.value ? 'lbl_day_cnt' : 'lbl_days_cnt';
  item.value = <TopCustomersByEarliestContactValue>{
    label,
    value: {
      count: item.value,
    },
  };

  return item;
});
